import type { GigTemplate } from "api/resources/templates";
import { atomWithStorage } from "jotai/utils";

export const connectSkillAtom = atomWithStorage<Omit<GigTemplate, "id" | "name" | "location_id"> | undefined>(
  "connect_skill",
  undefined,
  undefined,
  { getOnInit: true },
);
